import * as React from "react";
import { QualityStatus } from "../quality-control/qc-stat";

const R = 30;
// 2 * pie * R
const DASH_ARRAY = 2 * 3.14 * R;

class CircularProgressBar extends React.PureComponent<{ checks: QualityStatus[] }> {
  get numberPassed(): number {
    return this.props.checks.filter((c) => c === QualityStatus.Passed).length;
  }

  get numberChecked(): number {
    return this.props.checks.filter((c) => c !== QualityStatus.Missing).length;
  }

  get progress(): number {
    return DASH_ARRAY * (1 - this.numberPassed / this.numberChecked) || 1;
  }

  get progressText(): string {
    const bits = [];
    bits.push(`${this.numberPassed} out of ${this.numberChecked} passed`);
    const failed = this.props.checks.filter((c) => c === QualityStatus.Failed).length;
    const caution = this.props.checks.filter((c) => c === QualityStatus.Caution).length;
    if (failed) {
      bits.push(`${failed} failed`);
    }
    if (caution) {
      bits.push(`${caution} requires inspection`);
    }

    return bits.join(", ");
  }

  render() {
    return (
      <div className="circular-progress-bar">
        <svg width={R * 4} height={R * 4} viewBox={`0 0 ${R * 4} ${R * 4}`}>
          <circle
            cx={R * 2}
            cy={R * 2}
            r={R}
            strokeWidth="20px"
            fill="none"
            strokeDasharray={DASH_ARRAY}
            strokeDashoffset={this.progress}
          />
          <text
            x="50%"
            y="50%"
            stroke="black"
            strokeWidth="1px"
            dy=".3em"
            textAnchor="middle"
            alignmentBaseline="middle"
          >
            {this.numberPassed}/{this.numberChecked}
          </text>
        </svg>
        <div>{this.progressText}</div>
      </div>
    );
  }
}

export default CircularProgressBar;
